// src/services/adminBarterFiSurveyApi.js

import api from '../api';

export function getAdminSurveyOverview() {
  return api.get(
    '/admin/barterfi-survey/overview'
  );
}

export function getAdminSurveyResponses(
  params = {}
) {
  return api.get(
    '/admin/barterfi-survey/responses',
    {
      params,
    }
  );
}
